import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { apiFetch } from '../lib/api';
import { ArrowLeft } from 'lucide-react';

export function DashboardView() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    const controller = new AbortController();

    apiFetch<{ embedUrl: string }>(`/api/embed/dashboard/${id}`, {
      signal: controller.signal,
    })
      .then((res) => setEmbedUrl(res.embedUrl))
      .catch((err) => {
        if (!controller.signal.aborted) setError(err.message);
      });

    return () => controller.abort();
  }, [id]);

  if (error) {
    return (
      <div className="flex flex-1 items-center justify-center p-8">
        <p className="text-red-600">Failed to load dashboard: {error}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen">
      <div className="flex items-center gap-3 px-4 py-3 border-b bg-white shrink-0">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900"
        >
          <ArrowLeft className="size-4" />
          Back
        </button>
      </div>

      {!embedUrl ? (
        <div className="flex-1 p-6">
          <div className="h-8 w-64 animate-pulse rounded bg-gray-100 mb-4" />
          <div className="flex-1 min-h-[600px] animate-pulse rounded-xl bg-gray-100" />
        </div>
      ) : (
        <iframe
          src={embedUrl}
          className="flex-1 w-full border-0"
          allow="fullscreen"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
          title="Dashboard"
        />
      )}
    </div>
  );
}
